// extracted by mini-css-extract-plugin
module.exports = {"loading":"app-login_loading_2UJSN","img":"app-login_img_2bWiU"};